import { unwrap } from '../intent-client.js';
export function createConnectedWalletClient(transport) {
    return {
        async capability(surface, signal) {
            return unwrap(await transport.GET('/v1/onramp/connected-wallets/capability', {
                params: { query: { surface } },
                ...(signal ? { signal } : {}),
            })).available;
        },
        async create(input, signal) {
            return unwrap(await transport.POST('/v1/onramp/connected-wallets', {
                body: input,
                ...(signal ? { signal } : {}),
            }));
        },
        async get(id, signal) {
            return unwrap(await transport.GET('/v1/onramp/connected-wallets/{id}', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
        async reconcile(id, signal) {
            return unwrap(await transport.POST('/v1/onramp/connected-wallets/{id}/reconcile', {
                params: { path: { id } },
                ...(signal ? { signal } : {}),
            }));
        },
    };
}
